const trendsPT = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtros",
                "period": "Período",
                "store": "Loja",
                "label": "Gravadora",
                "release": "Lançamento",
                "track": "Faixa",
                "subuser": "Subusuário",
                "fetchingTrends": "Buscando tendências do banco de dados"
            },
            "button": {
                "resetFilters": "Redefinir Filtros"
            },
            "options": {
                "store": {
                    "allStores": "Todas as Lojas",
                    "downloadStores": "Lojas de Download",
                    "streamingStores": "Lojas de Streaming",
                    "streamStores": "Lojas de Stream"
                },
                "label": {
                    "allLabels": "Todas as Gravadoras"
                },
                "release": {
                    "allReleases": "Todos os Lançamentos"
                },
                "track": {
                    "allTracks": "Todas as Faixas"
                },
                "subuser": {
                    "selectSubuser": "Selecionar Subusuário"
                },
                "period": {
                    "last7Days": "Últimos 7 Dias",
                    "last14Days": "Últimos 14 Dias",
                    "last30Days": "Últimos 30 Dias",
                    "last45Days": "Últimos 45 Dias",
                    "last60Days": "Últimos 60 Dias",
                    "last75Days": "Últimos 75 Dias",
                    "last90Days": "Últimos 90 Dias"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Artista",
                    "songMixName": "Nome da Música/Mix",
                    "numberOfSales": "Número de Vendas"
                }
            }
        },
        "storeWiseSales": {
            "title": "Vendas por Loja",
            "label": {
                "amazonMusicStream": "Stream Amazon Music",
                "appleMusicStream": "Stream Apple Music",
                "beatportStream": "Stream Beatport",
                "deezerStream": "Stream Deezer",
                "facebookStream": "Stream Facebook",
                "instagramStream": "Stream Instagram",
                "itunesDownload": "Download iTunes",
                "pandoraStream": "Stream Pandora",
                "soundcloudStream": "Stream SoundCloud",
                "spotifyStream": "Stream Spotify",
                "tiktokStream": "Stream Tiktok",
                "traxsourceStream": "Stream Traxsource",
                "youtubeStream": "Stream Youtube",
                "youtubePremiumStream": "Stream Youtube Premium",
                "totalSales": "Vendas Totais",
                "storeMessage": "* Os rótulos das lojas estão em ordem alfabética (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Vendas por Território"
        },
        "salesByGender": {
            "title": "Vendas por Gênero",
            "label": {
                "male": "Masculino",
                "female": "Feminino",
                "nonBinary": "Não-binário",
                "unknown": "Desconhecido"
            }
        },
        "salesByAge": {
            "title": "Vendas por Idade",
            "label": {
                "male": "Masculino",
                "female": "Feminino",
                "genderOther": "Não-binário",
                "unknown": "Desconhecido",
                "ageWiseSales": "Vendas por Idade",
                "ageUnknown": "Idade Desconhecida"
            }
        },
        "message": {
            "noAccess": "Você não tem acesso a este módulo, por favor contate a equipe de suporte para mais informações.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>renove</1> sua assinatura para utilizar este recurso.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para utilizar este recurso."
        }
    }
};

export default trendsPT;